import React from 'react';
import useIsMobile from '../hooks/useIsMobile';

/**
 * Wählt pro Route zwischen Desktop- und Handy-Ansicht.
 * Die Desktop-Komponenten bleiben dadurch unangetastet.
 */
export default function ResponsivePage({ desktop: Desktop, mobile: Mobile, ...props }) {
  const isMobile = useIsMobile();
  return isMobile ? <Mobile {...props} /> : <Desktop {...props} />;
}
